/**
 * Returns true if the app is currently running on localhost or 127.0.0.1.
 * Useful for enabling local fallback behaviour (e.g. mock data) during development.
 */
export function isLocalHostRuntime(): boolean {
  return (
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
  );
}
